import Hero from "./Hero/Hero";
import Tiers from "./Tiers/Tiers";
import WorkOnEmu from "./WorkOnEmu/WorkOnEmu";
import WhatNeedsDoing from "./WhatNeedsDoing/WhatNeedsDoing";
import Faq from "./Faq/Faq";
import SponsorList from "./SponsorList/SponsorList";

import "./Build.css";

// --------------------------------------------------------------------------------------

export default function Build() {
	return (
		<>
			{/* Page head */}
			<title>BrainEm ￭ Build</title>
			<meta
				name="description"
				content="Let's build out the brain emulation tech tree."
			/>

			{/* ------------------------------------------------------------------------------ */}

			<Hero />

			<main>
				<Tiers />
				<WorkOnEmu />
				<WhatNeedsDoing />
				<Faq />
				<SponsorList />
			</main>
		</>
	);
}
